import CommonUiModel from "../common/commonUiModel";
import documentConfig from "./childGrids/Document";
import { useNavigate } from "react-router-dom";

const DocumentModel = new CommonUiModel({
    ...documentConfig,
    api: "HookupDocs",
    hideBreadcrumbInGrid: true,
    module: 'ScopeMaster',
    showHistory: false,
    permissions: { edit: false, add: true, delete: false },
    joinColumn: null
});

const HookupDocsGrid = ({ readOnly, baseFilters, equipmentId, id }) => {
    const navigate = useNavigate();
    const addHookupDocs = () => {
        navigate(`/validatescope/${equipmentId}/${id}/document/0?baseData={"EquipmentScopeId":${id}}`);
    };
    return (
        <DocumentModel.Grid
            baseFilters={baseFilters}
            onAddOverride={addHookupDocs}
            onCellDoubleClickOverride={() => {}}
            readOnly={readOnly}
        />
    );
};

export default HookupDocsGrid;